import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap'
import { useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export default function PaymentSuccess() {
	let query = new URLSearchParams(useLocation().search);

	const [summary, setSummary] = useState({});
	const [isGetSummary, setIsGetSummary] = useState(false);
	const [modalShow, setModalShow] = useState(false);
	const swalAlert = withReactContent(Swal);

	useEffect(() => {
		if (isGetSummary === false) {
			swalAlert.fire({
				title: 'Please Wait...',
				allowOutsideClick: false
			});
			swalAlert.showLoading();

			axios.get('/api/order/' + query.get("paymentID"))
				.then((response) => {
					setSummary(response.data[0]['transaction_data']);
					setIsGetSummary(true);

					swalAlert.close();
				});
		}
	}, []);

	return (
		<div id="product-hero">
			{isGetSummary ?
				<section id="body">
					<PromptMessage show={modalShow} onHide={() => setModalShow(false)} />
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="row shadow title position-relative">
									<h2 className="text-center m-3 m-sm-5 text-white fw-bold">Payment Successful</h2>
								</div>
								<div className="row content">
									{/* <div className="col-1"></div> */}
									<div className="col-12 shadow bg-white rounded p-5">
										<p>Hi {summary.name},</p>
										<p>Thank you for your payment. Your transaction has been successful subject to Anti Money Laundering Act and Sanction screening.</p>
										<p>The insurance coverage will only take effect upon approval from {getInsurerFullName(summary.insurer)}.</p>
										<p>Confirmation of coverage will be issued by {getInsurerFullName(summary.insurer)} to your email address after the approval process.</p>
										<p>Full premiums will be refunded by Howden if your application is not approved by {getInsurerFullName(summary.insurer)}.</p>
										<p>For any inquiries, please email us at <a href="mailto:instapol@howdengroup.com" target="_blank">instaPol@howdengroup.com</a></p>

										{summary.insurer == 'TUNEPROTECT' || summary.insurer == 'TuneProtect' ?
											<>
												<div className="mt-4">
												Important Information:
												</div>
												<div className="mb-4">
													No freelook. Refund only if the cancellation is requested before commencement of insurance and if the Trip is 
													cancelled due to Unforeseen Circumstances prior to the date of departure and the person will not make any claim for travel and
													cancellation charges. Note: Trip and Unforeseen Circumstances as defined in Policy Wording.
												</div>
											</>
										:
										""
										}
										<div className="card-deck mb-3 text-center">
											<div className="card mb-4 box-shadow">
												<div className="card-header" style={{ backgroundColor: "#c7ddea" }}>
													<h4 className="my-0" style={{ backgroundColor: "#c7ddea" }}>Purchase Summary</h4>
												</div>
												<div className="card-body p-0">
													<table className="table table-bordered table-condensed mb-0">
														<tbody>
															<tr>
																<td className="text-break w-50">Insurance Company <br /></td>
																<td className="text-break w-50 fw-bold">{getInsurerFullName(summary.insurer)}</td>
															</tr>
															<tr>
																<td className="text-break w-50">Transaction Reference No</td>
																<td className="text-break w-50 fw-bold">{summary.transaction_number}</td>
															</tr>
															<tr>
																<td className="text-break w-50">Total Annual Premium</td>
																<td className="text-break w-50 fw-bold">{"RM " + summary.total_payable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
										<a href="/Landing" className="btn btn-primary mt-3 mb-4 text-white" role="button">Back to Home</a>

										<div className="row my-4">
											<label className="col-12 col-form-label text-center fw-bold">You might also be interested in</label>
										</div>
										{/* Big Screen */}
										<div class="row justify-content-center d-none d-lg-block"> 
											<div class="col-12">
												<div id="product-card" class="text-center">
													<div class="row">
														<a href="https://instapol.my/motor" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
															<div class="product-item2">
																<img src="../images/motor.png" alt="Motor Insurance" height="50" class="mb-3"/>
																<p >Motor Insurance</p>
															</div>                                     
														</a>
															<a href="https://instapol.my/motor-extended" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/extended-motor.png" alt="Car Extended Warranty" height="50" class="mb-3"/>
																<p >Car Extended Warranty</p>
															</div>                                        
															</a>
															<a href="https://instapol.my/bike" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/bicycle.png" alt="Bicycle Insurance" height="50" class="mb-3"/>
																<p >Bicycle Insurance</p>
																</div>                                        
																	</a>
																									{/* <a href="/travel" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/travel.png" alt="Travel Insurance" height="50" class="mb-3"/>
																<p >Travel Insurance</p>
															</div>                                        </a> */}
																									<a href="https://instapol.my/sme" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/sme.png" alt="SME Medical" height="50" class="mb-3"/>
																<p >SME Medical</p>
															</div>                                        </a>
																									<a href="https://instapol.my/hho" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/house.svg" alt="HomeProtect" height="50" class="mb-3"/>
																<p >HomeProtect</p>
															</div>                                        </a>
																									<a href="https://instapol.my/criticalsafe" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/critical.svg" alt="Critical Illness" height="50" class="mb-3"/>
																<p >Critical Illness</p>
															</div>                                        
															</a>

															<a href="https://instapol.my/cyber" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																										<div class="product-item">
																<img src="../images/cyber.svg" alt="Critical Illness" height="50" class="mb-3"/>
																<p >Cyber Insurance</p>
																</div>                                        
															</a>
													</div>
												</div>
											</div>
										</div>

										{/* Small Screen */}
										<div className="d-block d-lg-none">
											<div className="row mb-3 text-center justify-content-around">
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/motor" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																<div class="product-item2">
																	<img src="../images/motor.png" alt="Motor Insurance" height="50" class="mb-3"/>
																	<p >Motor Insurance</p>
																</div>                                     
															</a>
												</div>
												{/* <div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="/travel" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/travel.png" alt="Travel Insurance" height="50" class="mb-3"/>
																	<p >Travel Insurance</p>
																</div>                                        </a>
												</div> */}
												
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/bike" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/bicycle.png" alt="Bicycle Insurance" height="50" class="mb-3"/>
																	<p >Bicycle Insurance</p>
																	</div>                                        
																		</a>
												</div>
												
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/sme" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/sme.png" alt="SME Medical" height="50" class="mb-3"/>
																	<p >SME Medical</p>
																</div>                                        </a>
												</div>
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/criticalsafe" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/critical.svg" alt="Critical Illness" height="50" class="mb-3"/>
																	<p >Critical Illness</p>
																</div>                                        
																</a>
												</div>
												
												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/motor-extended" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/extended-motor.png" alt="Car Extended Warranty" height="50" class="mb-3"/>
																	<p >Car Extended Warranty</p>
																</div>                                        
																</a>
												</div>

												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/cyber" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/cyber.svg" alt="Car Extended Warranty" height="50" class="mb-3"/>
																	<p >Cyber Insurance</p>
																</div>                                        
																</a>
												</div>

												<div className="col-6 col-md-2 mb-3 mb-sm-0">
												<a href="https://instapol.my/hho" class="card m-2 py-3 shadow rounded col d-flex align-items-center text-decoration-none justify-content-center" >
																											<div class="product-item">
																	<img src="../images/house.svg" alt="HomeProtect" height="50" class="mb-3"/>
																	<p >HomeProtect</p>
																</div>                                        </a>
												</div>
												
											</div>
										</div>

									</div>
									{/* <div className="col-1"></div> */}
								</div>

								
					
							

							</div>
						</div>
					</div>
				</section>
				:
				null
			}
		</div>
	);
}

function PromptMessage(props) {
	return (
		<Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
			<Modal.Header>
				<Modal.Title className="container-fluid">
					<div className="row">
						<button type="button" className="close" onClick={props.onHide}><i className="fa fa-times-circle text-end"></i></button>
					</div>
					<div className="row">
						<div className="col-12 text-center text-primary">
							<label className="col-form-label">
								Get your <strong>FREE*</strong> PA, Covid 19 &amp;
								<br />Dengue cover up to RM10,000</label>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col-12 text-center">
							<a className="btn btn-success badge-pill btn-lg px-5" href={process.env.MIX_INSTAPOL_DOMAIN}>Click Here</a>
						</div>
					</div>
				</Modal.Title>
			</Modal.Header>
		</Modal>
	);
}

function getInsurerFullName(short_name) {
	let full_name = '';

	if (short_name === 'CHUBB') {
		full_name = 'Chubb Insurance Malaysia Berhad';
	} else if (short_name === 'AXA') {
		full_name = 'AXA Affin General Insurance Berhad';
	} else if (short_name === 'AIG') {
		full_name = 'AIG Malaysia Insurance Berhad';
	} else if (short_name === 'MSIG') {
		full_name = 'MSIG Insurance (Malaysia) Bhd';
	} else if (short_name === 'ZurichTakaful') {
        full_name = 'Zurich General Takaful Malaysia Berhad';
    } else if (short_name === 'TuneProtect' || short_name === 'TUNEPROTECT') {
        full_name = 'Tune Insurance Malaysia Berhad';
    } else if (short_name === 'RHBI') {
        full_name = 'RHB Insurance Berhad';
    }


	return full_name;
}